"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DosageDoseAndRate = void 0;
/**
 * Indicates how the medication is/was taken or should be taken by the patient.
 */
var DosageDoseAndRate = /** @class */ (function () {
    function DosageDoseAndRate() {
    }
    return DosageDoseAndRate;
}());
exports.DosageDoseAndRate = DosageDoseAndRate;
